const isVideo = (card: CanvasCard.Card): card is CanvasCard.VideoCard =>
  card.content.type === 'Video';

export default isVideo;
